/**
 * @author        calvin@zumper.com (Calvin Yau)
 * @copyright     Copyright (c) 2018, Zumper
 * @description   NearbyHoods Schema Selectors
 */

import { compose } from 'redux'

/**
 *
 * @param {import('@zcode/state-type').State} state
 */
export const selectCurrentSearch = (state) => state.currentSearch

export const selectAllNearbyHoods = compose((state) => state.allNearbyHoods, selectCurrentSearch)

export const selectIsLoading = compose((state) => state.loading, selectAllNearbyHoods)

export const selectNearbyHoods = compose((state) => state.nearbyHoods, selectAllNearbyHoods)
